import { AuthService } from '../../../@core/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-welcome',
  templateUrl: './welcome.component.html',
})
export class WelcomeComponent implements OnInit {
  constructor(
    private authService: AuthService
) { }
  ngOnInit() {
    // this.authService.checkTokenExpired();
  }
}
